module.exports = __webpack_public_path__ + "images/line_friend_lp/mv-object-bottom_992e5897a409ef94127d505db025ca07.png";